// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();

(function () {
    jQuery(document).ready(function ($) {
        var navHeight = $('#header').height();
        // Preloader
        $('#preloader').addClass('load');
        setTimeout(() => {
            $('#preloader').hide();
        }, 1000);
        // Close nav
        $('.navbar-nav>li>a').on('click', function () {
            $('.navbar-collapse').collapse('hide');
            $('.navbar-brand').collapse('hide');
        });
        // slick
        $('.slider').slick({
            arrows: true,
            dots: true,
            appendDots: $('.dots-wrapper'),
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
        });
        // Hide nav belt while scrolling
        if ($(window).width() >= 992) {
            var topBeltHeight = $('.top-bar').innerHeight();
            var lastScrollTop = 0;
            $(window).scroll(function (event) {
                var st = $(this).scrollTop();
                if (st > lastScrollTop) {
                    $('#header').css('top', -topBeltHeight);
                } else {
                    $('#header').css('top', 0);
                }
                lastScrollTop = st;
            });
        }
        // scroll in IOS
        $('a[href^="#"]').on('click', function (event) {
            event.preventDefault();
            var target = $(this).attr('href');
            var scrollToPosition = $(target).offset().top - 80;
            window.scroll({
                top: scrollToPosition,
                left: 0,
                behavior: 'smooth',
            });
        });
    });
})();
